<template>
  <InvoiceInformationManager
    :showEditDeleteButtons="false"
    @invoiceSelected="handleInvoiceInformationChange"
  />
</template>

<script setup>
import { defineEmits } from "vue";
import InvoiceInformationManager from "@/components/DashboardLayout/dashboard-components/InvoiceInformationManager.vue";

const emit = defineEmits(["handleInvoiceInformationChange"]);

const handleInvoiceInformationChange = (invoiceInformation) => {
  emit("handleInvoiceInformationChange", invoiceInformation);
};
</script>
